import React from 'react';
import { Card } from 'sa-ui';

import './ReportBarChartComparativeDisciplines.scss';

const ReportBarChartComparativeDisciplines = (props) => {
  let colors = [
    '#001219',
    '#005F73',
    '#0A9396',
    '#94D2BD',
    '#E9D8A6',
    '#EE9B00',
    '#CA6702',
    '#BB3E03',
    '#AE2012',
    '#9B2226',
  ];
  return (
    <Card style={{ width: '100%' }} className="chart-mobile report-bar-chart--container">
      <div style={{ color: props.titleColor }}>
        <strong>
          <i className="pe-7s-graph1 mr-2" />
          {props.title}
        </strong>
      </div>
      <div className="label-comparative">
        {props.courses.length > 0 &&
          props.courses[0].curricularComponents.map((c, index2) => (
            <div className="flex">
              <div className="square" style={{ backgroundColor: colors[index2] }}></div>
              <div className="label">{c.id}</div>
            </div>
          ))}
      </div>
      <div style={{ marginTop: '60px' }}>
        <div
          className="report-bar-chart flexArea"
          style={{
            margin: props.area ? '20px 0 60px' : '20px 0',
            justifyContent: 'center',
            gap: '20px',
          }}
        >
          {props.courses.length > 0 &&
            props.courses.map((course, index) => (
              <div className="bar-wrapper">
                <div className="flex">
                  {course.curricularComponents.map((c, index2) => (
                    <div>
                      <div className="value" style={{ color: colors[index2] }}>
                        {c.average}%
                      </div>
                      <div
                        className="bar"
                        style={{
                          height: c.average * 3.5,
                          backgroundColor: colors[index2],
                          maxWidth: '25px',
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className="description">{course.courseName}</div>
              </div>
            ))}
        </div>
      </div>
    </Card>
  );
};
ReportBarChartComparativeDisciplines.propTypes = {};

ReportBarChartComparativeDisciplines.defaultProps = {
  evaluations: [],
  title: '',
};

export default ReportBarChartComparativeDisciplines;
